import React, { memo } from "react";
import { Card, CardContent } from "investira.react.components";
import { validators } from "investira.sdk";
import { Info } from "../";

const CardInfo = memo((props) => {
  const { cardProps, value, ...restProps } = props;

  if (validators.isEmpty(value)) {
    return null;
  }

  return (
    <Card
      {...cardProps}
      sx={{
        height: "100%",
        display: "flex",
        flex: "1 1",
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
      >
        <Info {...restProps} value={value} type="card" />
      </CardContent>
    </Card>
  );
});

CardInfo.displayName = "CardInfo";

export default CardInfo;
